import { WhitelabelConfig } from '@whitelabel/types';

const JapanicanWhitelabelConfig: WhitelabelConfig = {
    displayName: 'Japanican',
    termsOfUseUrl: 'https://www.japanican.com/content/terms-of-use',
    privacyPolicyUrl: 'https://www.japanican.com/content/privacy-policy',
};

export default JapanicanWhitelabelConfig;
